export default __webpack_public_path__ + "static/media/screen_2x.5c197b67.jpg";